export const offer = {
  checkoutUrl: 'https://the-argentine-mindset.impultienda.ar/checkout',
  priceToday: '$14 USD',
  priceTomorrow: '$69',
  spotsRemaining: 47,
  studentCount: '2,847+',
  satisfaction: '94%',
  ctaLabel: 'YES! Unlock The Argentine Mindset System Now',
  ctaSubLabel: 'Instant Access · 7-Day Money-Back Guarantee',
}

export const accessPoints: string[] = [
  'Download all 6 volumes in 60 seconds',
  'Works on any device (phone, tablet, laptop)',
  'Lifetime access (never expires)',
  'Email delivery + secure cloud storage',
  'Updated for life (new content added regularly)',
]
